import React from 'react';
import * as XLSX from 'xlsx';
import { FileSpreadsheet } from 'lucide-react';
import { useClasseContext } from '../../../context/ClasseContext';
import TestSpecifique from '../EvalNat/TestSpecifique';
const ExportAcquisEvalBilan = ({ EvalNat, evalBilan, evalBilanQuestions = [] }) => {

  const {classeNom} = useClasseContext()



    const calculateSuccessRate = (resultatsEleves) => {
        const questionStats = {};
        
        // Parcours des réponses des élèves
        resultatsEleves.forEach(eleve => {
          const { reponses } = eleve;
          if (!reponses) return; // On vérifie que l'objet n'est pas vide.
    
          // Parcours des réponses Automatisme et Résolution de problèmes
          Object.keys(reponses).forEach(type => {
            Object.keys(reponses[type]).forEach(questionId => {
              const score = reponses[type][questionId]?.score || 0;
    
              if (!questionStats[questionId]) {
                questionStats[questionId] = {
                  total: 0,
                  correct: 0
                };
              }
    
              // Mise à jour des statistiques pour cette question
              questionStats[questionId].total += 1;
              if (score === 1) {
                questionStats[questionId].correct += 1;
              }
            });
          });
        });
    
        // Calcul du pourcentage de réussite pour chaque question
        const successRates = Object.keys(questionStats).map(questionId => {
          const { total, correct } = questionStats[questionId];
          return {
            questionId,
            successRate: ((correct / total) * 100).toFixed(2) + '%'
          };
        });
    
        return successRates;
      };

      const calculateSuccessRateNat = (evaluation, selectedQuestions) => {
        const questionStats = {};
        // Parcours des réponses des élèves dans l'évaluation nationale
        evaluation.eleves_reponses.forEach(eleve => {
          // Parcourir uniquement les questions sélectionnées
      
          selectedQuestions.forEach(({ question_num, type, id }) => {
            
          
            const response = eleve?.reponses?.[type]?.[question_num];
     
            if (response) {
                const { score = 0 } = response;
        
                if (!questionStats[id]) {
                  questionStats[id] = {
                    total: 0,
                    correct: 0,
                  };
                }
        
                questionStats[id].total += 1;
                if (score === 1) {
                  questionStats[id].correct += 1;
                }
              }
            });
          });
        
          // Calcul du pourcentage de réussite pour chaque question
          const successRatesNat = Object.keys(questionStats).map(questionId => {
            const { total, correct } = questionStats[questionId];
            return {
              questionId,
              successRate: ((correct / total) * 100).toFixed(2) + '%',
            };
          });
        
          return successRatesNat;
        };

// Ici on récupère uniquement les questions présentes dans EvalBilan.
const formatTypeLabel = (typeLabel) => {

  if (typeLabel.startsWith("Compréhension de l'écrit")) {
    if(classeNom[0] === '6') {
      // Enlève "Compréhension de l'écrit" et prend ce qui reste
      const remaining = typeLabel.substring("Compréhension de l'écrit".length).trim();
      
      // Sépare par espaces et prend le dernier mot
      const parts = remaining.split(' ').filter(p => p); // filter pour enlever les chaînes vides
      
      
      return parts[parts.length - 1]; // Retournera "Sommeil" 
    }
    return typeLabel.substring("Compréhension de l'écrit".length).trim();
  }
  if (typeLabel.startsWith("Compétences langagières et linguistiques")) {
    return "Compétence";
  }
  if(typeLabel === "Automatisme"){
    return "Automatismes"
  }
  if(typeLabel==="Résolution de problèmes"){
    return "Problèmes"
  }
  return typeLabel;
};
const selectedQuestions = evalBilan.reduce((acc, eleve) => { eleve.reponses && 
    Object.keys(eleve.reponses).forEach(type => {
      Object.keys(eleve.reponses[type]).forEach(questionId => {
        if (!acc.some(q => q.id === parseInt(questionId))) {
          const questionFromEval = EvalNat.questions.find(q => q.id === parseInt(questionId))
            || evalBilanQuestions.find(q => q.id === parseInt(questionId));
          if (questionFromEval) {
            acc.push({ id: questionFromEval.id, question_num: questionFromEval.question_num ,
               type: formatTypeLabel(questionFromEval.type_label)});
          }
        }
      });
    });
    return acc;
  }, []);

      const successRates = calculateSuccessRate(evalBilan);
      const successRatesNat = calculateSuccessRateNat(EvalNat, selectedQuestions);

      
      const exportToExcel = () => {
        // Préparer les données formatées pour l'export
        const dataAutomatismes = [];
        const dataProblemes = [];
    
        selectedQuestions.forEach(({ question_num, type, id }) => {
          const rateBilan = successRates.find(rate => rate.questionId === String(id));
          const rateNat = successRatesNat.find(rate => rate.questionId === String(id));

          const successRateBilan = rateBilan?.successRate || "0%";
          const hasNatData = !!rateNat;
          const successRateNat = hasNatData ? rateNat.successRate : "—";
          const evolution = hasNatData
            ? (parseFloat(successRateBilan) - parseFloat(rateNat.successRate)).toFixed(2) + '%'
            : "—";

          const row = {
            "Question Numéro": question_num,
            "SuccessRate EvalNat": successRateNat,
            "SuccessRate EvalBilan": successRateBilan,
            "Taux d'évolution": evolution
          };
    
          if (type === "Automatismes") {
            dataAutomatismes.push(row);
          } else if (type === "Problèmes") {
            dataProblemes.push(row);
          }
        });
    
        // Ajouter un titre au bloc
        const worksheetData = [
          { "Bloc": "Automatismes" },
          ...dataAutomatismes,
          {},
          { "Bloc": "Résolution de Problèmes" },
          ...dataProblemes,
        ];
    
        // Générer la feuille Excel
        const worksheet = XLSX.utils.json_to_sheet(worksheetData, { skipHeader: false });
        const workbook = XLSX.utils.book_new();
    
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Acquis Bilan');
    
        // Exporter le fichier
        XLSX.writeFile(workbook, 'AcquisEvalBilan.xlsx');
      };
    
      return (
         <button
                   onClick={exportToExcel}
                    className="flex 3xl:text-lg text-base items-center gap-2 bg-green-600
                     hover:bg-green-700 text-white px-6 py-3 rounded-lg transition-colors shadow-lg hover:shadow-xl"
                  >
                    <FileSpreadsheet className="w-5 h-5" />
                    Exporter les données
                  </button>
      );
    };

export default ExportAcquisEvalBilan;